<h2 class="text-center">{{ ReadOnly ? "View " : "Manage " }} User Roles</h2>
<hr />
@if (loading===false){

@if (treeControl) {
<mat-tree [dataSource]="dataSource" [treeControl]="treeControl">
	<mat-tree-node *matTreeNodeDef="let node">
		@if (!ReadOnly) {
		<mat-checkbox [checked]="checklistSelection.isSelected(node)" (change)="todoLeafItemSelectionToggle(node)">
			{{ node.Description }}
		</mat-checkbox>
		}
		@if (ReadOnly) {
		<div>
			<p>
				<span [ngClass]="{ strike: checklistSelection.isSelected(node) !== true }">{{
					node.Description
					}}</span>
				@if (checklistSelection.isSelected(node) === true) {
				<mat-icon>done_all</mat-icon>
				}
			</p>
		</div>
		}
	</mat-tree-node>
	<mat-tree-node *matTreeNodeDef="let node; when: hasChild">
		<button matTreeNodeToggle [attr.aria-label]="'toggle ' + node.filename">
			<mat-icon class="expand">
				{{ treeControl.isExpanded(node) ? "expand_more_outlined" : "chevron_right" }}
			</mat-icon>
		</button>
		{{ node.Description }}
	</mat-tree-node>
</mat-tree>
}
}@else {
<div class="loading">
	<mat-spinner diameter="50"></mat-spinner>
</div>
}